<template>
    <CCol v-bind="$attrs">
        <ValidationProvider
            tag="div"
            :vid="vid"
            :name="name"
            :rules="rules"
            v-slot="{ errors }"
        >
            <CInputCheckbox @update:checked="emitCheckbox" :checked.sync="checked">
                <template #label>
                    <slot :name="label">{{ autoLabel }}</slot>
                    <span v-if="required" class="text-danger">*</span>
                </template>

                <template #invalid-feedback>
                    <span class="invalid-feedback d-block">{{ errors[0] }}</span>
                </template>
                <template v-for="(_, slot) in $slots">
                    <template :slot="slot">
                        <slot :name="slot"></slot>
                    </template>
                </template>
            </CInputCheckbox>
        </ValidationProvider>
    </CCol>
</template>

<script>
import { DefaultInputProps } from './defaultProps'
export default {
    name: 'CCustomInputCheckbox',
    props: {
        ...DefaultInputProps,
    },
    data() {
        return {
            checked: Boolean(this.value)
        }
    },
    computed: {
        autoLabel() {
            return this.label === '' ? this.name : this.label
        },
    },
    watch: {
        value(newVal) {
           this.checked = Boolean(newVal)
        }
    },
    methods: {
        emitCheckbox() {
            this.checked = !this.checked
            this.$emit('input', this.checked)
            this.$emit('change', this.checked)
        }
    }
}
</script>